export enum PagePath {
  Home = '/',
  Wating = '/wating',
  Rejected = '/rejected',
  Disabled = '/disabled',
  MyPage = '/mypage',
  SignIn = '/signin',
  SignUp = '/signup',
  SignOut = '/signout',
  Time = '/time',
  TimeRecord = '/time/record',
  TimeRecordByUser = '/time/record/:id',
  TimeTaskCategory = '/time/category',
  TimeAnalysis = '/time/analysis',
  Developer = '/developer',
  Admin = '/admin',
  AdminRole = '/admin/role',
  AdminCredentials = '/admin/credentials',
  AdminSetting = '/admin/setting',
  User = '/user',
  UserList = '/user/list',
  UserAnalysis = '/user/analysis',
  Project = '/project',
  ProjectList = '/project/list',
  ProjectCustomer = '/project/customer',
  ProjectCategory = '/project/category',
  ProjectBusinessCategory = '/project/category/business',
  ProjectIndustryCategory = '/project/category/industry',
  AnalysisProject = '/analysis/project',
  AnalysisProjectOrders = '/analysis/project/orders',
  AnalysisProjectSales = '/analysis/project/sales',
  Logs = '/logs',
}
